const ns = "USER";
export const RECEIVE_SESSION = `${ns}_RECEIVE_SESSION`;
export const RECEIVE_USER = `${ns}_RECEIVE_USER`;
export const UPDATE_PHONE = `${ns}_UPDATE_PHONE`;
export const UPDATE_USER = `${ns}_UPDATE_USER`;
export const UPDATE_USER_ID = `${ns}_UPDATE_USER_ID`;
